import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { EmployeesSetting } from 'modules/attendance/hooks/useFetchEmployeesSettings'

interface Props {
  employeesSetting: EmployeesSetting
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const PolicyCard = ({ employeesSetting, setModalOpen }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const {
    desktopClockin,
    qrCodeClockin,
    geolocation,
    faceRecognition,
    mobileClockin,
    idClockSharedDevice,
    policyName,
    activeEmployeeIds,
    defaultPolicy,
    hasFlagsEnabled,
  } = employeesSetting

  const { grey, radical } = Tag.Types

  const routeParams = {
    id: 'time_tracking',
    settingId: employeesSetting.id.toString() || 'default',
    tabId: 'time_ranges',
  }
  const route = navigation.settings.time_tracking.settingId.tabId.fullPath(routeParams)

  const onClick = () => {
    navigate(route)
    setModalOpen(false)
  }

  return (
    <Box justifyContent="spaceBetween" width="full" flexDirection="column" gap="s12">
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Box flexDirection="column" gap="s2">
          <Text.Normal weight="semibold">{policyName}</Text.Normal>
          <Text.Normal ellipsis size="200">
            {i18n.tp('time_tracking.settings.employees_count', {
              count: activeEmployeeIds.length,
            })}
          </Text.Normal>
        </Box>
        <Box alignSelf="center">
          <Button onClick={onClick} type="secondary" iconName="arrow-right" />
        </Box>
      </Box>
      {(defaultPolicy || hasFlagsEnabled) && (
        <Box flexDirection="row" gap="s8" width="s300">
          {defaultPolicy && (
            <Tag type={radical}>{i18n.t('time_tracking.settings.tags.default')}</Tag>
          )}
          {desktopClockin && <Tag type={grey}>{i18n.t('time_tracking.settings.tags.desktop')}</Tag>}
          {mobileClockin && <Tag type={grey}>{i18n.t('time_tracking.settings.tags.mobile')}</Tag>}
          {qrCodeClockin && <Tag type={grey}>{i18n.t('time_tracking.settings.tags.qr')}</Tag>}
          {geolocation && (
            <Tag type={grey}>{i18n.t('time_tracking.settings.tags.geolocation')}</Tag>
          )}
          {faceRecognition && (
            <Tag type={grey}>{i18n.t('time_tracking.settings.tags.face_recognition')}</Tag>
          )}
          {idClockSharedDevice && (
            <Tag type={grey}>{i18n.t('time_tracking.settings.tags.id_clock_shared_device')}</Tag>
          )}
        </Box>
      )}
    </Box>
  )
}

export default observer(PolicyCard)
